import logo from '../image/logo.png';
import { Carousel } from 'antd';
import vodinlogo from '../../vodin_logo/image/vodin_logo.svg';
export function GSLogoView(){

 
  return (   
<Carousel autoplay dots={false} effect={"fade"}>
<div>
      <h3 style={{
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
  }}>
        <img 
        alt="Vodin Logo"
      width={"80%"}      
      src={logo}
      style={{ margin: '10%'}}
    /></h3>
    </div>

    <div>
      <h3 style={{
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
  }}>
     <img 
        alt="Vodin Logo"
      width={"60%"}      
      src={vodinlogo}
      style={{ margin: '10%'}}
    /></h3>
    </div>
    </Carousel>
    );
}